import React from 'react';
import {
  FaCity,
  FaMapMarkerAlt,
  FaShip,
  FaIndustry,
  FaTree,
  FaStar,
} from 'react-icons/fa';
import './Cidades.css';

const Cidades = () => {
  const cidades = [
    {
      id: 'maputo',
      nome: 'Maputo',
      icon: FaCity,
      cor: '#007bff',
      descricao:
        'Capital de Moçambique, Maputo é o principal centro financeiro, cultural e político do país. Com uma população de cerca de 1,2 milhões de habitantes, é a cidade mais populosa de Moçambique. Conhecida pelas suas praias deslumbrantes, arquitectura colonial e vibrante vida noturna, Maputo é o coração da logística e comércio moçambicano.',
      disponivel: true,
    },
    {
      id: 'matola',
      nome: 'Matola',
      icon: FaIndustry,
      cor: '#28a745',
      descricao:
        'Matola é a segunda maior cidade de Moçambique, com uma população superior a 1 milhão de habitantes. Localizada a poucos quilómetros de Maputo, é um importante polo industrial e residencial. A cidade alberga o maior parque industrial do país, sendo um centro estratégico para a logística e distribuição de mercadorias.',
      disponivel: true,
    },
    {
      id: 'nampula',
      nome: 'Nampula',
      icon: FaMapMarkerAlt,
      cor: '#e83e8c',
      descricao:
        'Nampula é a terceira maior cidade de Moçambique, com uma população de cerca de 750 mil habitantes. É a capital da província do mesmo nome e um importante centro comercial, educacional e religioso. Conhecida pela sua diversidade cultural e pelo icónico mercado central, Nampula é um polo de crescimento no norte do país.',
      disponivel: false,
    },
    {
      id: 'beira',
      nome: 'Beira',
      icon: FaShip,
      cor: '#dc3545',
      descricao:
        'Beira é a segunda maior cidade de Moçambique e a maior do centro do país, com cerca de 530 mil habitantes. O seu porto é um dos mais importantes do Oceano Índico, sendo uma porta de entrada para o comércio regional. A cidade é conhecida pela sua arquitectura colonial, praias e pelo seu papel estratégico na logística de importação e exportação.',
      disponivel: false,
    },
    {
      id: 'chimoio',
      nome: 'Chimoio',
      icon: FaTree,
      cor: '#fd7e14',
      descricao:
        'Chimoio é a capital da província de Manica, com uma população de cerca de 360 mil habitantes. É um importante centro agrícola e comercial, localizada numa região fértil e de grande produção alimentar. A cidade tem uma rica história e é um ponto de passagem para o Zimbabwe, tornando-a estratégica para o comércio transfronteiriço.',
      disponivel: false,
    },
  ];

  return (
    <div className="cidades-container">
      <div className="cidades-header">
        <h1 className="cidades-titulo">
          Cidades Atendidas pela <span className="destaque-amarelo">Carga Fácil</span>
        </h1>
        <p className="cidades-subtitulo">
          Expandimos a nossa rede logística para levar eficiência e confiança a todo o país
        </p>
      </div>

      {/* Cidades Disponíveis */}
      <div className="cidades-section">
        <div className="section-badge disponivel-badge">
          <FaStar className="badge-icon" /> Disponível Agora
        </div>
        <div className="cidades-cards">
          {cidades
            .filter((c) => c.disponivel)
            .map((cidade) => (
              <div className={`cidade-card ${cidade.id}`} key={cidade.id}>
                <div className="card-status disponivel">Disponível</div>
                <div className="icon-wrapper" style={{ color: cidade.cor }}>
                  <cidade.icon className="cidade-icon" />
                </div>
                <h2>{cidade.nome}</h2>
                <p>{cidade.descricao}</p>
              </div>
            ))}
        </div>
      </div>

      {/* Cidades em Breve */}
      <div className="cidades-section em-breve-section">
        <div className="section-badge embreve-badge">
          <FaStar className="badge-icon" /> Em Breve
        </div>
        <div className="cidades-cards">
          {cidades
            .filter((c) => !c.disponivel)
            .map((cidade) => (
              <div className={`cidade-card ${cidade.id}`} key={cidade.id}>
                <div className="card-status embreve">Em Breve</div>
                <div className="icon-wrapper" style={{ color: cidade.cor }}>
                  <cidade.icon className="cidade-icon" />
                </div>
                <h2>{cidade.nome}</h2>
                <p>{cidade.descricao}</p>
              </div>
            ))}
        </div>
      </div>

      {/* CTA Final */}
      <div className="cidades-cta">
        <h3>Quer ver a sua cidade na lista?</h3>
        <p>
          Estamos a expandir rapidamente. Se a sua cidade ainda não está disponível,
          entre em contacto connosco para saber quando chegaremos.
        </p>
        <a href="mailto:contacto@cargafacil.co.mz" className="cta-cidades-button">
          Sugerir Cidade
        </a>
      </div>
    </div>
  );
};

export default Cidades;